import _concatInstanceProperty from '@babel/runtime-corejs3/core-js/instance/concat';

function prependPrefix(cls) {
  var _context;

  var prefix = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'prelude';
  return _concatInstanceProperty(_context = "".concat(prefix, "-")).call(_context, cls);
}

export { prependPrefix };
